import SectionGradientButton from '../Button/SectionGradientButton';
// import ShareButton from '../Button/ShareButton';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useThumbnailUrl from '../../hooks/useThumbnailUrl';
import { useSetRecoilState } from 'recoil';
import { otpModalState } from '../../recoil/otp/otpModalAtom';
import SCREEN_SIZES from '../../constants/screenSizes';
import PRODUCT_TYPES from '../../constants/productTypes';

const MainCarouselCard = ({ item, isLogin }) => {
  const [buttonText, setButtonText] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth <= SCREEN_SIZES.MOBILE_SCREEN_WIDTH);
  const setOtpLogin = useSetRecoilState(otpModalState);
  const imageUrl = useThumbnailUrl(item.thumbnail_info, 624);

  useEffect(() => {
    // 카드별 버튼 텍스트 변경
    setButtonText(item.product_type === PRODUCT_TYPES.DIGITAL ? t('purchase') : t('play'));
  }, [item.type, t]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileScreen(window.innerWidth <= SCREEN_SIZES.MOBILE_SCREEN_WIDTH);
    };

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const moveProductVideoDetailPage = (id) => {
    navigate(`/product-video-detail/${id}`);
  };

  const moveProductDigitalDetailPage = (id) => {
    navigate(`/product-digital-detail/${id}`);
  };

  const moveClipPage = (clipmetaid) => {
    if (!isLogin) {
      setOtpLogin(true);
      return;
    }
    navigate(`/video-clip-detail/${clipmetaid}`);
  };
  const moveLiveClipPage = (clipmetaid, live_clip_id) => {
    if (!isLogin) {
      setOtpLogin(true);
      return;
    }
    navigate(`/video-live-detail/${clipmetaid}?clip_live_id=${live_clip_id}`);
  };

  const movePage = () => {
    // 비디오 상품
    if (item.product_type === PRODUCT_TYPES.VIDEO) {
      // 일반 클립
      if (item.is_free && item.is_replay) {
        moveClipPage(item.clipmetaid);
        // 라이브 클립
      } else if (!item.is_replay && item.live_clip_id) {
        moveLiveClipPage(item.clipmetaid, item.live_clip_id);
      } else {
        moveProductVideoDetailPage(item.id);
      }
      // 디지털 상품
    } else {
      moveProductDigitalDetailPage(item.id);
    }
  };

  // 모바일 클릭 이벤트
  const handleMobileClick = () => {
    if (isMobileScreen) {
      movePage();
    }
  };

  // 데스크탑 클릭 이벤트
  const handleDesktopClick = () => {
    if (!isMobileScreen) {
      movePage();
    }
  };

  return (
    <>
      <div className={'main-carousel-card'} onClick={handleMobileClick}>
        <figure className={'main-carousel-img-group'}>
          <img
            fetchpriority='low'
            src={imageUrl || '/images/img_no_img.png'}
            alt='main carousel image'
            className={'main-carousel-img'}
            width={'624'}
            height={'624'}
            onError={(e) => {
              e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
              e.target.src = '/images/img_no_img.png';
            }}
            decoding={'async'}
          />
        </figure>
        <div className={'main-carousel-txt-group'}>
          <div className={'main-carousel-info-group'}>
            {/* 비디오 상품 노출 정보, 디지털 상품 미노출 */}
            {item.product_type === PRODUCT_TYPES.VIDEO ? (
              <p className={'main-carousel-badge mb-hide'}>
                {!item.is_replay ? t('live_state_live') : t('live_state_replay')}
              </p>
            ) : null}

            <h3 className={'main-carousel-title'} lang={'en'}>
              {item.title}
            </h3>
            {/* 비디오 상품 노출 정보, 디지털 상품 미노출 */}
            {item.product_type === PRODUCT_TYPES.VIDEO ? (
              <p className={'main-carousel-date'}>{dayjs(item.start_at).format('YYYY.MM.DD HH:mm')} (KST)</p>
            ) : null}
          </div>
          <div className={'main-carousel-button-group mb-hide'}>
            <SectionGradientButton onClick={handleDesktopClick} buttonText={buttonText} />
            {/* 0123 결정사항으로 해당 버튼 제외 */}
            {/*https://vlending.atlassian.net/browse/VD-6172?focusedCommentId=66891*/}
            {/*<ShareButton onClick={onButtonClick} />*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainCarouselCard;
